import React, { useState, useEffect } from 'react';
import { services } from '../data/services';
import ScrollToTopLink from '../components/ScrollToTopLink';
import { ArrowRight } from 'lucide-react';

const Services = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading state for background image
    const img = new Image();
    img.src = "/images/capture.jpg";
    img.onload = () => setIsLoading(false);
  }, []);

  return (
    <div className="relative min-h-screen">
      {/* Loading State */}
      {isLoading && (
        <div className="absolute inset-0 bg-gray-100 flex items-center justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#1a237e]"></div>
        </div>
      )}

      {/* Background Image */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url("/images/capture.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          opacity: 0.5  // Increased from 0.3 for better visibility
        }}
      />

      {/* Gradient Overlay */}
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-gray-900/20 to-gray-900/60" /> {/* Reduced overlay opacity */}

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-8 text-center">
          Nos Services
        </h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((service) => (
            <ScrollToTopLink
              key={service.id}
              to={`/services/${service.id}`}
              className="group relative bg-white/40 backdrop-blur-sm p-6 rounded-lg 
                shadow-lg hover:shadow-2xl transition-all duration-300 ease-out
                border border-white/30 hover:border-blue-400/50
                hover:bg-white/50 hover:scale-105 hover:-translate-y-1
                cursor-pointer overflow-hidden"
            >
              {/* Hover Gradient Effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-blue-500/0 via-blue-500/0 to-blue-500/0 
                group-hover:from-blue-500/10 group-hover:via-blue-500/5 group-hover:to-blue-500/10
                transition-all duration-300 ease-out -z-10" />
              
              <div className="text-blue-600 mb-4 flex items-center justify-center md:justify-start
                group-hover:text-blue-500 transform group-hover:scale-110 transition-all duration-300">
                {React.createElement(service.icon, { 
                  size: 32,
                  className: "group-hover:rotate-12 transition-transform duration-300"
                })}
              </div>
              
              <h2 className="text-xl font-semibold mb-2 text-gray-800
                group-hover:text-blue-700 transition-colors duration-300">
                {service.title}
              </h2>
              
              <p className="text-gray-700 mb-4 transition-colors duration-300
                group-hover:text-gray-900">
                {service.description}
              </p>
              
              <span className="inline-flex items-center text-blue-600 hover:text-blue-700
                transform group-hover:translate-x-2 transition-all duration-300">
                <span className="relative">
                  En savoir plus
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-600
                    group-hover:w-full transition-all duration-300" />
                </span>
                <ArrowRight className="ml-2 transform group-hover:translate-x-1
                  transition-transform duration-300" size={20} />
              </span>
            </ScrollToTopLink>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;